import {Component, OnInit, ViewChild} from '@angular/core';
import {EventsService} from '../../events.service';
import {GlobalService} from '../../../global.service';
import {
  PerfectScrollbarConfigInterface,
  PerfectScrollbarComponent,
  PerfectScrollbarDirective
} from 'ngx-perfect-scrollbar';
import {Title} from "@angular/platform-browser";
@Component({
  selector: 'app-snickers-e-cup',
  templateUrl: './snickers-e-cup.component.html',
  styleUrls: ['./snickers-e-cup.component.scss']
})
export class SnickersECupComponent implements OnInit {
  language: any;
  langChosen = 'en';
  public config: PerfectScrollbarConfigInterface = {
    // suppressScrollX:true
  };
  @ViewChild(PerfectScrollbarComponent) componentRef?: PerfectScrollbarComponent;
  @ViewChild(PerfectScrollbarDirective) directiveRef?: PerfectScrollbarDirective;

  constructor(public eventService: EventsService, public globalService: GlobalService , private titleService:Title) {
    this.titleService.setTitle('snickers-e-cup')
    if (this.globalService.isBrwoser) {
      if (localStorage.getItem('language')) {
        this.language = require('./lang/' + localStorage.getItem('language') + '.json');
        this.langChosen = localStorage.getItem('language');
      } else {
        this.language = require('./lang/en.json');
      }
    }
  }

  ngOnInit() {
  }

  languageChange(value) {
    if (this.globalService.isBrwoser) {
      this.langChosen = value;
      this.language = require('./lang/' + value + '.json');
      this.globalService.language = value;
      localStorage.setItem('language', value);
    }
  }
}
